'use strict';
const Router = require('autor');
const screen = require('./screen.js');
const helpers = require('./helpers.js');
import {randInt} from './helpers.js';


let gridXLength = null;
let gridXSize = null;
let gridXPadding = null;
let gridYLength = null;
let gridYSize = null;
let gridYPadding = null;

function updateGrid() {
  let desirablePadding = parseInt(window.getComputedStyle(document.querySelector('.title-card__text.title-card__text--all'), null).getPropertyValue('padding-left'));

  let r = getDotRadius();
  gridXLength = Math.floor((window.innerWidth - desirablePadding) / (r * 2 + desirablePadding));
  gridXPadding = ((-2 * gridXLength * r) + window.innerWidth) / (gridXLength + 1);
  gridXSize = 2 * r + gridXPadding;

  gridYLength = Math.floor((window.innerHeight - desirablePadding) / (r * 2 + desirablePadding));
  gridYPadding = ((-2 * gridYLength * r) + window.innerHeight) / (gridYLength + 1);
  gridYSize = 2 * r + gridYPadding;
}

window.addEventListener('resize', function() {
  updateGrid();
}.bind(this));

updateGrid();

function hideAllButMostRightDot() {
  let dots = document.querySelectorAll('#title-card circle');
  let mostRightDot = dots[0];
  for (var i = 0; i < dots.length; i++) {
    if (helpers.hasClass(dots[i], 'title-card__dot--most-right')) helpers.removeClass(dots[i], 'title-card__dot--most-right');

    // if (dots[i].classList.contains('title-card__dot--most-right')) dots[i].classList.remove('title-card__dot--most-right');
    if (parseInt(mostRightDot.getAttribute('cx')) < parseInt(dots[i].getAttribute('cx'))) mostRightDot = dots[i];
  }
  mostRightDot.classList.add('title-card__dot--most-right');
}

function init() {
  document.getElementById('title-card').addEventListener('click', function() {
    toggleMenu();
  }.bind(this));
  for (var i = 0; i < 13; i++) {
    document.querySelector('#title-card svg').appendChild(createDot());
  }
}

function getDotRadius() {
  let docWidth = window.innerWidth;
  if (docWidth >= 1440) return docWidth * 0.025;
  if (docWidth > 768) return docWidth * 0.03;
  else return docWidth * 0.05;
}

function createDot() {
  let dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  dot.setAttribute('r', getDotRadius());
  randomizeDotPosition(dot);
  return dot;
}

function randomizeDotPosition(dot) {
  dot.setAttribute('cx', randInt(0, gridXLength - 1) * gridXSize + getDotRadius() + gridXPadding);
  dot.setAttribute('cy', randInt(0, gridYLength - 1) * gridYSize + getDotRadius() + gridYPadding);
}

function animate() {
  if (!document.getElementById('title-card').classList.contains('title-card--animating')) return;

  let dots = document.querySelectorAll('#title-card svg circle');
  for (let i = 0; i < dots.length; i++) {
    randomizeDotPosition(dots[i]);
  }

  document.getElementById('title-card').classList.add('title-card--will-animate');
  setTimeout(animate, 2400);
}

function toggleMenuDesktop() {
  let titleCard = document.getElementById('title-card');

  if (document.body.classList.contains('home-menu') == true) {
    document.body.classList.remove('home-menu');
    document.body.classList.add('home');
    titleCard.classList.remove('menu');
    document.getElementById('title-card').classList.add('title-card--animating');
  } else if (document.body.classList.contains('home')) {
    document.body.classList.remove('home');
    document.body.classList.add('home-menu');
    titleCard.classList.add('menu');
    document.getElementById('title-card').classList.remove('title-card--animating');
    hideAllButMostRightDot();
  }
}

function toggleMenuMobile() {
  if (document.body.classList.contains('menu-open')) {
    document.body.classList.remove('home-menu');
    document.body.classList.add('home');
    document.body.classList.remove('menu-open');
  } else {
    document.body.classList.remove('home');
    document.body.classList.add('home-menu');
    document.body.classList.add('menu-open');
  }
}

function toggleMenu() {
  if (screen.isMobile()) toggleMenuMobile();
  else toggleMenuDesktop();
}

module.exports = {
  init,
  animate,
  toggleMenu
}



// WEBPACK FOOTER //
// ./src/js/title-card.js